const DUBLIN_POSTAL_DISTRICT_REGEX = /^Dublin\s+(?:[1-9]|1\d|2[0-4]|6W)$/i;

export const isDublinPostalDistrictTown = (
  value: string | undefined
): boolean => {
  return !!value && DUBLIN_POSTAL_DISTRICT_REGEX.test(value.trim());
};

export const normalizeDublinPostalDistrictTown = (
  value: string | undefined
): string | undefined => {
  if (!value) {
    return value;
  }

  return isDublinPostalDistrictTown(value) ? 'Dublin' : value;
};
